var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"voltage"},[_c('div',{staticClass:"voltage-curve"},[_vm._v(" 电压曲线 ")]),_c('div',{staticClass:"voltage-table"},[_c('a-table',{attrs:{"columns":_vm.voltageColumns,"data-source":_vm.voltageData},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('a',[_vm._v("删除")])]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }